import { request } from "@/service/request.js";


export function sendGuideRegister(options) {
  return request.call(this, {
      url: "openapi/web/customer/register",
      method: 'POST',
      data:options
  });
};

export function sendCompanyRegister(options) {
  return request.call(this, {
      url: "openapi/web/company/register",
      method: 'POST',
      data:options
  });
};

export function getupload(param) {
  return request.call(this, {
      url: "openapi/web/image/upload",
      method: 'POST',
      data:param
  });
};

// export function getupload(param) {
//   return request.call(this, {
//       url: "openapi/web/image/download/2021-08-18/header1629268348062678332",
//       method: 'POST',
//       data:param
//   });
// };
